import React from 'react'
import Icon from '../../../ui/Icon/Icon'
import './PhoneLinks.sass'
import { useContext } from 'react'
import { AuthContext } from '../../../App'

function PhoneLinks() {
  // const { contacts } = useContext(AuthContext)
  return (
    <div className="PhoneLinks">
      <a href={`tel:79110630001`} className="PhoneIcon">
        <Icon name="phone" weight="solid" />
      </a>
      <a href={`tel:79110630001`} className="PhoneIcon Telegram">
        <Icon name="telegram" weight="brand" />
      </a>
      <div className="Content">
        <a href={`tel:79110630001`} className="PhoneNumber ">
          +7 (911) 063-00-01
        </a>
        <span className="Description">Пн-Вс: 08:00 - 22:00</span>
      </div>
    </div>
  )
}

export default PhoneLinks
